  <template>
  <div :style="dashboardStyle"
       @dragover="allowSignalMeasureDrop"
       @drop="(event) => dragToDashbordCmp(event, chartData, componentIndex)"
       class="dashboard-group">
    <div class="cmp-handle">
      <el-dropdown>
                    <span class="el-dropdown-link">
                        <i class="el-input__icon el-icon-more"></i>
                    </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="chartData.dataSources.length>0">
            当前信号：
            <span style="color:#2258cc;font-weight: bold;font-size: 14px">{{chartData.dataSources[0].text}}</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-select @change="loadStyle" placeholder="选择主题" style="width: 120px" v-model="topic">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in options">
              </el-option>
            </el-select>
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',  componentIndex)"
                            divided
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <dash-board-chart :chartData="chartData" :topic="topic" style="width: 100%;height: 90%;margin:5% auto;"
                      v-if="!loading"></dash-board-chart>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import dashboardChart from '@/components/common/echarts/DashboardChart.vue';
import { PROJECT_NODE_TYPE } from '@/common/enums';

export default {
  name: 'dashboardCmp',
  mounted() {
    this.loadStyle();
  },
  data() {
    return {
      type: 1, // 默认拖拽的是信号节点
      dashboardStyle: 'width: 100%;height:100%',
      topic: 'default',
      loading: false,
      options: [{
        value: 'default',
        label: '默认主题',
      }, {
        value: 'vintage',
        label: '复古',
      }, {
        value: 'dark',
        label: '深色',
      }, {
        value: 'macarons',
        label: '马卡龙',
      }, {
        value: 'shine',
        label: '闪耀',
      }, {
        value: 'roma',
        label: '罗马',
      }],
    };
  },
  props: {
    componentIndex: {
      type: Number,
    },
    startStatus: {
      type: Object,
    },
    /**
             * 当前组件的数据
             */
    chartData: {
      type: Object,
    },
  },
  components: {
    dashBoardChart: dashboardChart,
  },
  computed: {
    ...mapState('Engineering', ['componentStyleInfoArray', 'dragTreeNodeType']),
    ...mapGetters('Engineering', ['activedPanelData', 'getCurCmpStatus']),
  },
  methods: {
    ...mapMutations('Engineering', ['clickComponent',
      'addDashboard',
      'deleteComponent',
      'addSingnalToDashboaord',
      'setAnchorPointId',
      'setAnchorKeyWord']),
    ...mapActions('Engineering', ['deleteCpt']),
    clickDashboardCmp(index) {
      this.clickComponent({ componentName: 'dashboard', cmpIndex: index, cmpType: 'dashboard' });
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    dragToDashbordCmp(event, item, cmpIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addSingnalToDashboaord({ dragNode, componentIndex: cmpIndex, type: this.type });
      this.$message.success(`成功添加${dragNode.text}至仪表盘`);

      // const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      // this.addDashboard({ dragNode, componentIndex: cmpIndex, type: this.type });
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL) {
        event.dataTransfer.dropEffect = 'copy';
      } else if (this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
        this.type = 3;
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    loadStyle() {
      this.loading = true;
      setTimeout(() => this.loading = false, 50);
    },
  },
};
</script>

<style lang="scss">
  .dashboard-group {
    position: relative;
    border: dashed 1px #eee;
    width: 100%;
    min-height: 160px;
    overflow: hidden !important;

    .cmp-handle {
      position: absolute;
      top: 0;
      right: 0;

      .el-input__icon {
        line-height: 25px;
      }
    }

    &:hover {
      animation: 1s shadowChange infinite;
    }

    @keyframes shadowChange {
      0% {
        box-shadow: 0 0 2px #eee;
      }
      50% {
        box-shadow: 0 0 2px #aaa;
      }
      100% {
        box-shadow: 0 0 2px #eee;
      }
    }

    .title {
      font-size: 14px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/Dashboard.vue